

<app-header  [no_home]="true" [no_cart]="true" title="Order Details"></app-header>

<ion-content [ngClass]="db.ismobile ? 'mobile-bg':''">
    <app-orderdetail [order_detail]="order_detail"></app-orderdetail>
</ion-content>
